export const PLACEHOLDER_IMG =
  "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='400' height='400' fill='%23F9F7F3'/%3E%3Ctext x='50%25' y='50%25' fill='%23839788' font-family='sans-serif' font-size='24' text-anchor='middle' dominant-baseline='middle'%3ENoumabou%3C/text%3E%3C/svg%3E";

export function fcfa(amount) {
  const n = Number(amount || 0);
  return `${n.toLocaleString("fr-FR").replace(/,/g, " ")} FCFA`;
}

export const ORDER_STATUS_LABELS = {
  nouvelle: "Nouvelle",
  en_preparation: "En préparation",
  livree: "Livrée",
  annulee: "Annulée",
};

export const DELIVERY_LABELS = {
  a_livrer: "À livrer",
  en_cours: "En cours",
  livre: "Livré",
};

export const PAYMENT_LABELS = {
  paye: "Payé",
  en_attente: "En attente",
  partiel: "Partiel",
};

export const PAYMENT_METHOD_LABELS = {
  tmoney: "Tmoney",
  flooz: "Flooz",
  cash: "Cash (à la boutique)",
  livraison: "Payer à la livraison",
  paygate: "Paiement en ligne",
};

export const SOURCE_LABELS = {
  boutique: "Boutique",
  tiktok: "TikTok",
  whatsapp: "WhatsApp",
  direct: "Vente directe",
};

export function statusColor(status) {
  return (
    {
      nouvelle: "bg-blue-100 text-blue-700",
      en_preparation: "bg-amber-100 text-amber-700",
      livree: "bg-green-100 text-green-700",
      annulee: "bg-red-100 text-red-700",
      paye: "bg-green-100 text-green-700",
      en_attente: "bg-amber-100 text-amber-700",
      partiel: "bg-orange-100 text-orange-700",
      a_livrer: "bg-slate-100 text-slate-700",
      en_cours: "bg-blue-100 text-blue-700",
      livre: "bg-green-100 text-green-700",
    }[status] || "bg-slate-100 text-slate-700"
  );
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
